import CookieConsent from 'Components/General/CookieConsent'
import GAWithConsent from 'Components/General/GAWithConsent'
import withVerification from 'Components/WithVerification'
import Admin from 'Pages/Admin'
import Login from 'Pages/Auth/Login'
import Logout from 'Pages/Auth/Logout'
import OAuthSuccess from 'Pages/Auth/OAuthSuccess'
import Recovery from 'Pages/Auth/Recovery'
import ResetPassword from 'Pages/Auth/ResetPassword'
import SignUp from 'Pages/Auth/SignUp'
import Business from 'Pages/Business'
import VerifyBusinessEmail from 'Pages/Business/Verify'
import BusinessLanding from 'Pages/BusinessLanding'
import DBUsers from 'Pages/DBUsers'
import DatabaseViewer from 'Pages/DatabaseViewer'
import HMIContact from 'Pages/HMIContact'
import Index from 'Pages/Index'
import Invite from 'Pages/Invite'
import Landing from 'Pages/Landing'
import MyProfile from 'Pages/MyProfile'
import Page404 from 'Pages/Page404'
import Personal from 'Pages/Personal'
import QRCode from 'Pages/QRCode'
import SendInvite from 'Pages/SendInvite'
import Privacy from 'Pages/Static/Privacy'
import Terms from 'Pages/Static/Terms'
import Support from 'Pages/Support'
import Tasks from 'Pages/Tasks'
import Verified from 'Pages/Verified'
import VerifyEmail from 'Pages/VerifyEmail'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet-async'
import { connect } from 'react-redux'
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom'
import FAQ from './Pages/FAQ'
import Learn from './Pages/Learn/Learn'
import Pricing from './Pages/Pricing/Pricing'
import SignUpNotify from 'Pages/SignUpNotify'

import ErrorBoundary from 'Components/ErrorBoundary'

class App extends Component {
  render() {
    window.__APP_RENDERED__ = true;
    const { isAuthenticated, isAdmin, localHideCookieConsent } = this.props
    console.log('[DEBUG HMI] App.js render called! isAuthenticated:', isAuthenticated, 'isAdmin:', isAdmin, 'path:', window.location.pathname)
    return (
      <ErrorBoundary>
        <Helmet>
          <title>HeresMyInfo.com</title>
        </Helmet>
        <Router>
          <GAWithConsent>
            <Switch>
              <Route path='/' exact component={!isAuthenticated ? Landing : withVerification(Index)} />
              <Route path='/login' exact component={Login} />
              <Route path='/login/oauth' exact component={OAuthSuccess} />
              <Route path='/logout' exact component={Logout} />
              <Route path='/resetPassword' exact component={ResetPassword} />
              <Route path='/recovery' exact component={Recovery} />
              <Route path='/signup' exact component={SignUp} />
              <Route path='/learn' exact component={Learn} />
              <Route path='/verified' component={Verified} />
              <Route path='/privacy' component={Privacy} />
              <Route path='/terms' component={Terms} />
              <Route path='/sign-up-notify' exact component={SignUpNotify} />
              <Route path='/support' exact component={Support} />
              <Route path='/business/:businessId/verify/:propertyId' component={VerifyBusinessEmail} />
              <Route path='/business' exact component={!isAuthenticated ? BusinessLanding : withVerification(Business)} />
              <Route path='/business' component={withVerification(Business)} />
              <Route path='/personal' component={withVerification(Personal)} />
              <Route path='/qr/:code' component={QRCode} />
              <Route path='/verifyEmail' component={VerifyEmail} />
              <Route path='/hmiconnections/:connectionId' component={HMIContact} />
              <Route path='/invite/:inviteId' component={Invite} />
              <Route path='/faqs' exact component={FAQ} />
              <Route path='/send-invite' exact component={SendInvite} />
              <Route path='/tasks' exact component={Tasks} />
              <Route path='/pricing' exact render={(props) => {
                if (isAuthenticated) {
                  return <Pricing {...props} />
                }
                return <Redirect to="/login" />
              }} />
              <Route path='/personalpricing' exact render={() => <Redirect to="/pricing" />} />
              <Route path='/businesspricing' exact render={() => <Redirect to="/pricing" />} />
              {isAdmin ? <Route path='/admin/db-users' exact component={DBUsers} /> : null}
              {isAdmin ? <Route path='/admin/database' exact component={DatabaseViewer} /> : null}
              <Route path={["/my-profile", "/my-profile/"]} component={MyProfile} />

              {isAdmin ? (
                <Route path='/admin' component={Admin} />
              ) : (
                <Route path='/admin' render={() => {
                  if (isAuthenticated) {
                    return <Redirect to={{ pathname: '/logout', state: { logout: true } }} />
                  }
                  return <Redirect to="/login" />
                }} />
              )}
              <Route component={Page404} />
            </Switch>
          </GAWithConsent>
        </Router>
        {!localHideCookieConsent && <CookieConsent />}
      </ErrorBoundary>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isAdmin: state.auth.isAuthenticated && state.auth.currentUser && state.auth.currentUser.isAdmin === true,
    localHideCookieConsent: state.settings.localHideCookieConsent
  }
}

export default connect(mapStateToProps)(App)
